import React from 'react'
import styles from "../styles/TabOptions.module.scss";
import { reportColumnMetaData } from '../constants/earningsReport';

const TabOptions = (props) => {

  return (
    <>
    <ul className={styles.tabWrapper}>
      {props.options.map((option) => {
        let activeOption;
        if(props.optionsObject[option]) activeOption = styles.isActive;
        return (
          <div
            key={option}
            className={activeOption}
            onClick={() => props.handleClick(option)}
            >
           {reportColumnMetaData[option].title}
          </div>
        );
      })} 
    </ul>
  </>
  )
}

export default TabOptions
